// src/routes/HomeRoutes.tsx
import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import MainLayout from "../layouts/MainLayout";
import NotFound from "../pages/static/NotFound";
import Home from "../pages/static/Home";
import Register from "../pages/auth/Register";
import Login from "../pages/auth/Login";
import ForgotPassword from "../pages/auth/ForgotPassword";
import ResetPassword from "../pages/auth/ResetPassword";
import VerifyEmail from "../pages/auth/VerifyEmail";
import CheckEmail from "../pages/auth/CheckEmail";
import EventLandingPage from "../pages/events/EventLandingPage";
import EventRegistration from "../pages/events/EventRegistration";
import PrivacyPolicy from "../pages/static/PrivacyPolicy";
import DataProtection from "../pages/static/DataProtection";

const MainRoutes: React.FC = () => {
  return (
    <Routes>
      {/* Layout Route */}
      <Route element={<MainLayout />}>
        <Route path="/" element={<Home />} />
        <Route path="/home" element={<Navigate to="/" replace />} />
        <Route path="/register" element={<Register />} />
        <Route path="/login" element={<Login />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/verify-email" element={<VerifyEmail />} />
        <Route path="/check-email" element={<CheckEmail />} />
        <Route path="*" element={<NotFound />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/data-protection" element={<DataProtection />} />
      </Route>
      <Route path="/event" element={<EventLandingPage />} />
      <Route path="/event/register" element={<EventRegistration />} />
    </Routes>
  );
};

export default MainRoutes;
